import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrashcanIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <mask id="trashcan-icon_svg__a" width={20} height={20} x={0} y={0} maskUnits="userSpaceOnUse" style={{
      maskType: "alpha"
    }}><path fill="currentColor" d="M0 0h20v20H0z" /></mask>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g mask="url(#trashcan-icon_svg__a)"><path fill="currentColor" d="M5.833 17.5q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177V5a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.594-.24H7.5q0-.354.24-.593.24-.24.593-.24h3.334q.354 0 .593.24.24.24.24.593h3.333q.354 0 .594.24t.24.594-.24.593a.8.8 0 0 1-.594.24v10.833q0 .688-.49 1.177-.489.49-1.176.49zM14.167 5H5.833v10.833h8.334zm-5.834 9.167q.354 0 .594-.24t.24-.594V7.5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594v5.833q0 .354.24.594t.594.24m3.334 0q.354 0 .593-.24.24-.24.24-.594V7.5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594v5.833q0 .354.24.594t.594.24" /></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default SvgTrashcanIcon;